import mitt from 'mitt';

const eventEmitter = mitt();

export const useGlobalEventEmitter = () => eventEmitter;
